import React from 'react';
import {withRouter} from 'react-router-dom';
import {User} from 'api';
import {LoadingPage} from 'components/loading-page';
import {ShowIf} from 'components/utils';
import {DateTime} from 'components/UI/DateTime';
import {connect} from 'react-redux';
import {NoContent} from 'components/no-content';
import {numberFormat} from 'components/utils';
import {getPrice} from 'lib/convert';

const ORDER_STATUSES = {
  AWAITING: 0,
  FORWARED: 1,
  CANCELED: 2,
};

class OrderHistoryContent extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      data: [],
      isLoading: false,
      count: 0,
      skip: 0,
      limit: 10
    };
    this.loadMore = this.loadMore.bind(this);
  }

  componentDidMount() {
    if (this.props.user) {
      this.setState({isLoading: true});
      User.actions.countOrder.request({id: this.props.user.id}).then((response) => {
        this.setState({count: response.data.count, isLoading: false});
        this.getList();
      }).catch((error) => {
        this.setState({isLoading: false});
      });
    }
  }

  getList() {
    this.setState({isLoading: true});
    let params = {
      id: this.props.user.id,
      filter: {
        limit: this.state.limit,
        skip: this.state.skip,
        order: 'createdAt DESC'
      }
    };
    User.actions.orders.request(params).then(response => {
      let orders = this.state.data;
      response.data.map((item, idx) => {
        orders.push(item);
      });
      this.setState({data: orders, isLoading: false});
    }).catch(() => {
      this.setState({isLoading: false});
    });
  }

  loadMore() {
    this.setState({skip: this.state.skip + 10}, () => {
      this.getList();
    });
  }

  showDetail(id) {
    this.props.history.push(`/user/order-history/${id}`);
  }

  render() {
    return (
      <section className="order-history the-news list-complaint">
        <LoadingPage isShow={this.state.isLoading} />
        <ShowIf condition={this.state.data.length > 0}>
          <table className="complaint-table">
            <thead className="complaint-table-header">
              <tr>
                <th>Ngày đặt hàng</th>
                <th>Tổng tiền</th>
                <th>Trạng thái</th>
              </tr>
            </thead>
            <tbody className="complaint-table-list">
              {
                this.state.data.map((item, idx) => {
                  return (
                    <tr className="complaint-item" onClick={this.showDetail.bind(this, item.id)}>
                      <td><DateTime dateTime={item.createdAt} format="HH:mm MM/DD/YYYY" /></td>
                      <td>{getPrice(item.amount)}</td>
                      <td>
                        <ShowIf condition={item.status === ORDER_STATUSES.AWAITING}>
                          <span className="label-primary">Đang tiếp nhận</span>
                        </ShowIf>
                        <ShowIf condition={item.status === ORDER_STATUSES.FORWARED}>
                          <span className="label-success">Đã tiếp nhận</span>
                        </ShowIf>
                        <ShowIf condition={item.status === ORDER_STATUSES.CANCELED}>
                          <span className="label-danger">Đã hủy</span>
                        </ShowIf>
                      </td>
                    </tr>
                  );
                })
              }
              <ShowIf condition={!this.state.isLoading && this.state.data.length > 0 && (this.state.skip + this.state.limit) < this.state.count}>
                <tr>
                  <td colSpan={3} className="btn-see-more-wrap">
                    <button className="btn-see-more" onClick={this.loadMore}>Xem Thêm</button>
                  </td>
                </tr>
              </ShowIf>
            </tbody>
          </table>
        </ShowIf>
        <ShowIf condition={!this.state.isLoading && this.state.data.length == 0}>
          <NoContent content='Không có lịch sử nào' height={600}/>
        </ShowIf>
      </section>
    );
  }
}

const mapStateToProps = state => {
  return {
    user: state.auth.user
  };
};

export default withRouter(connect(mapStateToProps)(OrderHistoryContent));



// WEBPACK FOOTER //
// ./components/users/sub-view/order-history-content/OrderHistoryContent.jsx